<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="5">
        <el-input placeholder="保单号" v-model="params.policyNo" style="width: 100%">
          <el-button slot="append" icon="el-icon-search" @click="searchData"></el-button>
        </el-input>
      </el-col>
      <el-col :span="5">
        <el-input placeholder="身份证号" v-model="params.id_no" style="width: 100%">
          <el-button slot="append" icon="el-icon-search" @click="searchData"></el-button>
        </el-input>
      </el-col>


<!--      <el-select v-model="params.is_pass" placeholder="通过" clearable @change="searchData" style="width: 15%">-->
<!--        <el-option-->
<!--          v-for="item in passList"-->
<!--          :key="item.value"-->
<!--          :label="item.label"-->
<!--          :value="item.value">-->
<!--        </el-option>-->

<!--      </el-select>-->
<!--      <el-select v-model="params.is_send" placeholder="返现" clearable @change="searchData" style="width: 10%">-->
<!--        <el-option-->
<!--          v-for="item in sendList"-->
<!--          :key="item.value"-->
<!--          :label="item.label"-->
<!--          :value="item.value">-->
<!--        </el-option>-->

<!--      </el-select>-->
      <el-col :span="2">
<!--        <el-button type="primary" @click="exportData" v-loading="exportloading">导出</el-button>-->
      </el-col>

    </el-row>
    <el-table :data="userList" :height="wheight-130" v-loading="loading">
      <el-table-column prop="id" label="ID" width="100"></el-table-column>
      <el-table-column prop="policy_no" label="保单号" width="250">
        <template slot-scope="scope">
          {{scope.row.policy_no}}
        </template>
      </el-table-column>
      <el-table-column prop="endor_no" label="批改单号" width="250">
        <template slot-scope="scope">
          <!--        <el-tag :color="scope.row.tag_color" size="mini" :style="'color:'+scope.row.font_color"></el-tag>-->
          {{scope.row.endor_no}}
        </template>
      </el-table-column>

      <el-table-column prop="id_type" label="证件类型" width="250">
        <template slot-scope="scope">
          {{scope.row.id_type}}
        </template>
      </el-table-column>
      <el-table-column prop="id_no" label="身份证号" width="250">
        <template slot-scope="scope">
          {{scope.row.id_no}}
        </template>
      </el-table-column>
      <el-table-column prop="ret_money" label="退费金额" width="250">
        <template slot-scope="scope">
          {{scope.row.ret_money}}
        </template>

      </el-table-column>
      <el-table-column prop="ret_time" label="退保时间" width="250">
        <template slot-scope="scope">
          {{scope.row.ret_time}}
        </template>
      </el-table-column>


      <el-table-column prop="ret_endtime" label="审核通过时间" width="250">
        <template slot-scope="scope">
          {{scope.row.ret_endtime}}
        </template>
      </el-table-column>


      <el-table-column prop="premium" label="承保保费" width="250">
        <template slot-scope="scope">
          {{scope.row.premium}}
        </template>
      </el-table-column>


      <el-table-column prop="installments_total" label="分期数量" width="250">
        <template slot-scope="scope">
          {{scope.row.installments_total}}
        </template>
      </el-table-column>

      <el-table-column prop="installments_num" label="月缴" width="250">
        <template slot-scope="scope">
          {{scope.row.installments_num}}
        </template>
      </el-table-column>
      <el-table-column prop="flowid" label="定额方案" width="250">
        <template slot-scope="scope">
          {{scope.row.flowid}}
        </template>
      </el-table-column>
      <el-table-column prop="end_policy_type" label="保单状态类型" width="250">
        <template slot-scope="scope">
          {{scope.row.end_policy_type}}
        </template>
      </el-table-column>
      <el-table-column prop="endorTypeTips" label="批改类型小类" width="250">
        <template slot-scope="scope">
          {{scope.row.endorTypeTips}}
        </template>
      </el-table-column>

<!--      <el-table-column prop="holderCredentialType" label="投保人证件类型" width="250">-->
<!--        <template slot-scope="scope">-->
<!--          {{scope.row.holderCredentialType}}-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column prop="issueName" label="被保人名称" width="250">-->
<!--        <template slot-scope="scope">-->
<!--          {{scope.row.issueName}}-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column prop="issuePhone" label="被保人联系方式" width="250">-->
<!--        <template slot-scope="scope">-->
<!--          {{scope.row.issuePhone}}-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column prop="issueEmail" label="被保人邮箱" width="250">-->
<!--        <template slot-scope="scope">-->
<!--          {{scope.row.issueEmail}}-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column prop="issueCredentialNo" label="被保人证件号" width="250">-->
<!--        <template slot-scope="scope">-->
<!--          {{scope.row.issueCredentialNo}}-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column prop="issueCredentialType" label="被保人证件类型" width="250">-->
<!--      <template slot-scope="scope">-->
<!--        {{scope.row.issueCredentialType}}-->
<!--      </template>-->
<!--    </el-table-column>-->
<!--      <el-table-column prop="relationType" label="投被保人关系" width="250">-->
<!--        <template slot-scope="scope">-->
<!--          {{scope.row.relationType}}-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column prop="socialSecurityType" label="有无社保" width="250">-->
<!--        <template slot-scope="scope">-->
<!--          {{scope.row.socialSecurityType}}-->
<!--        </template>-->
<!--      </el-table-column>-->


<!--      <el-table-column label="操作" width="380">-->
<!--        <template slot-scope="scope">-->
<!--          <el-button type="text" @click="toEdit(scope.row)">查看图片</el-button>-->
<!--          &lt;!&ndash;          <el-button type="text" @click="isPassAction(scope.$index, scope.row)">通过</el-button>&ndash;&gt;-->
<!--          <el-button type="text" @click="isSendAction(scope.$index, scope.row)"-->
<!--                     v-if="scope.row.is_trial=='1'&&scope.row.is_send=='未返现'">返现-->
<!--          </el-button>-->
<!--          <el-button type="text" @click="editAction(scope.$index, scope.row)">编辑</el-button>-->
<!--          <el-button type="text" @click="isSendEmployee(scope.$index, scope.row)"-->
<!--                     v-if="scope.row.is_send_employee=='0'">给员工返现-->
<!--          </el-button>-->


<!--          <el-button type="text" @click="isTrial(scope.$index, scope.row)" v-if="scope.row.is_trial!='1'">试算</el-button>-->
<!--          <el-button type="text" @click="isPassAction(scope.$index, scope.row)" v-if="scope.row.is_pass!= '已通过'">上传发票-->
<!--          </el-button>-->

<!--        </template>-->
<!--      </el-table-column>-->


    </el-table>
    <div v-if="total_count > params.page_size" class="content-center content-top-padded">
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :current-page.sync="params.page"
        :total="total_count" :page-size="params.page_size">
      </el-pagination>

    </div>

  </div>
</template>
<script>
  import {mapGetters} from 'vuex'
  // eslint-disable-next-line no-unused-vars
  import {Message} from 'element-ui'
  // eslint-disable-next-line no-unused-vars



  import { getTaiKangOrderStatus } from'../../../api/taikang.js'
  export default {
    data() {
      return {
        isEdit: false,
        userList: [],
        loading: false,
        total_count: 0,
        params: {
          page: 1,
          page_size: 20,
          card: '',
          employee_id: '',
          pharmacistTel: '',
          phone: '',
          store_inkid: '',
          invoice_pic: '',
          channelStoreNo: '',
        },
        passList: [
          {label: '已通过', value: 1},
          {label: '未通过', value: 0},
          {label: '通过失败', value: 2}
        ],
        sendList: [
          {label: '已返现', value: 1},
          {label: '未返现', value: 0}
        ],
        resList: [{label: 'true', value: 'true'},
          {label: 'false', value: 'false'}
        ],
        form: {
          id: '',
          img: '',
          description: ''
        },
        editDialog: false,
        memberTagDialog: false,
        employeeDialog: false,
        passDialog: false,
        predefineColors: ['#ff4500', '#ff8c00', '#ffd700', '#90ee90', '#00ced1', '#1e90ff', '#c71585']
      }
    },
    computed: {
      ...mapGetters([
        'wheight'
      ])
    },
    methods: {
      toEdit(e) {
        this.editDialog = true
        this.form = e;
        this.url = e.front_photo;
        this.srcList = [e.front_photo, e.reverse_photo];
      },
      handleClose(e) {
        this.editDialog = false;
      },
      invoiceLabelsDialog(e){
        this.invoiceLabelsDialog=false;
        this.getDataList()
      },
      exportData() {
        this.exportloading = true
        this.params.export = 1
        getOrderData(this.params).then(res => {
          this.exportloading = false
          if (res.data.status) {
            this.$message({
              type: 'success',
              message: '已加入执行队列，请在设置-导出列表中下载'
            })
            return
          } else if (res.data.url) {
            this.downloadUrl = res.data.url
            this.downloadName = res.data.filename
            this.downloadView = true
          } else {
            this.$message({
              type: 'error',
              message: '无内容可导出 或 执行失败，请检查重试'
            })
            return
          }
        }).catch(error => {
          this.exportloading = false
        })
      },
      // eslint-disable-next-line camelcase
      handleCurrentChange(page_num) {
        // eslint-disable-next-line camelcase
        this.params.page = page_num
        this.getDataList()
      },
      addTemplate() { // 添加
        this.employeeDialog = true
        // eslint-disable-next-line standard/object-curly-even-spacing
        this.form = {tag_id: '', tag_name: '', tag_color: '#ff1939', font_color: '#ffffff', description: ''}
      },

      saveEmployeeData() {
        this.employeeDialog = false
        if (this.form.id) {
          // eslint-disable-next-line no-undef
          updateEmployee(this.form).then(res => {
            if (res.data.data) {
              this.$message({
                type: 'success',
                message: '保存成功'
              })
              this.getDataList()
            }
          })

        } else {
          this.$message.error('缺少Id')
          this.getDataList()
          //新增方法
          // eslint-disable-next-line no-undef
          // saveKaika(this.form).then(res => {
          //   if (res.data.data) {
          //     this.$message({
          //       type: 'success',
          //       message: '新增成功'
          //     })
          //     this.getDataList()
          //   }
          // })
        }
      },
      editAction(index, row) { // 编辑
        this.form = row
        this.employeeDialog = true
      },
      isSendAction(index, row) {
        this.$confirm('确认返现, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          sendData(row.id).then(response => {

            this.$message({
              message: '返现成功',
              type: 'success',
              duration: 5 * 1000
            }),
              this.getDataList()
          }).catch(() => {
            this.$message({
              type: 'error',
              message: '返现失败'
            })
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      },
      isSendEmployee(index, row) {

        this.$confirm('确认给员工返现, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          sendEmployee(row.id).then(response => {
            console.log(response.data.data.msg_code)
            if (response.data.data.msg_code == '0') {
              this.$message({
                type: 'error',
                message: response.data.data.res
              })
            } else {
              this.$message({
                message: '返现成功',
                type: 'success',
                duration: 5 * 1000
              })
            }
            this.getDataList()
          }).catch(() => {
            this.$message({
              type: 'error',
              message: '返现失败'
            })
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      },
      isTrial(index, row) {
        this.$confirm('开始试算, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          console.log(row.channelOrderNo)
          isTrial(row.channelOrderNo).then(response => {

            if (response.data.data.code == '200') {

              this.$message({
                message: response.data.data.message,
                type: 'success',
                duration: 5 * 1000
              })
            } else {
              this.$message({
                type: 'error',
                message: '失算失败'
              })
            }
            this.getDataList()
          }).catch(() => {
            console.log(row.channelOrderNo)
            this.$message({
              type: 'error',
              message: '试算失败'
            })
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      },
      saveInvoice() {
        //上传发票
        this.passDialog = false
        if (this.form.id) {
          // eslint-disable-next-line no-undef
          saveInvoice(this.form).then(res => {
            if (res.data.data) {
              this.$message({
                type: 'success',
                message: '保存成功'
              })
              this.getDataList()
            }
          })
        } else {
          this.$message.error('缺少Id')
          this.getDataList()
         }
      },
      isPassAction(index, row) {
        //上传发票弹框
        this.form = row
        this.passDialog = true
      },
      preview(index, row) { // 预览弹框
        this.dialogVisible = true
        this.dataInfo = row
      },
      searchData() {
        if (!(/^1[3-9][0-9]\d{8}$/.test(this.params.phone)) && this.params.phone != '') {
          this.$message.error('请输入正确手机号')
        } else if (!(/^1[3-9][0-9]\d{8}$/.test(this.params.pharmacistTel)) && this.params.pharmacistTel != '') {
          this.$message.error('请输入正确手机号')
        } else {
          this.params.page = 1
          this.getDataList()
        }
      },
      getDataList() {
        this.loading = true
        getTaiKangOrderStatus(this.params).then(response => {
          this.userList = response.data.data.list
          this.total_count = response.data.data.total_count
          this.loading = false
          // eslint-disable-next-line handle-callback-err
        }).catch(error => {
          this.loading = false
          this.$message({
            type: 'error',
            message: '获取列表信息出错'
          })
        })
      },
      getTaskTime(strDate) {
        let date = new Date(strDate)
        let y = date.getFullYear()
        let m = date.getMonth() + 1
        m = m < 10 ? ('0' + m) : m
        let d = date.getDate()
        d = d < 10 ? ('0' + d) : d
        let str = y + '-' + m + '-' + d
        return str
      },
      getTimeStr(date) {
        return this.getTaskTime(new Date(parseInt(date) * 1000))
      },
      handleCancelLabelsDialog() {
        this.employeeDialog = false
        this.getDataList()
      },
    },
    mounted() {
      this.getDataList()
    }
  }
</script>
<style scoped lang="scss">
  .el-row {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }

    img {
      width: 90%;
    }
  }

  .el-col {
    border-radius: 4px;
  }

  .bg-purple-dark {
    background: #99a9bf;
  }

  .bg-purple {
    background: #d3dce6;
  }

  .bg-purple-light {
    background: #e5e9f2;
  }

  .grid-content {
    border-radius: 4px;
    min-height: 10px;

    img {
      width: 90%;
    }
  }

  .row-bg {
    padding: 10px 20px;
    background-color: #f9fafc;
  }

  .service-label .el-checkbox:first-child {
    margin-left: 15px;
  }

  .service-label .el-input:first-child {
    margin-left: 15px;
  }

  .grid-detail {
    max-height: 300px;
    overflow-y: scroll;
    margin-bottom: 20px;
  }

  .el-carousel {
    width: 375px;
  }

  .img123 {
    width: 100px;
    height: 100px;
  }
</style>
<style lang="scss">
  .grid-detail {
    table, .detail-content-wrap, .detail-content-item {
      width: 100% !important;
    }

    img {
      width: 100%;
    }
  }

  .grid-attribute {
    table {
      width: 100% !important;
    }
  }
</style>



// WEBPACK FOOTER //
// taikang_policy_status.vue?92bd6c82